import { useEffect } from 'react';
import { STATISTICS_SECTION_ID } from './StatisticsSection';

export const useScrollToParentNode = ({ hash, parentRef, offset = 0 }) => {
    useEffect(() => {
        if (!parentRef) return;
        if (hash !== `#${STATISTICS_SECTION_ID}`) return;
        /**
         * On mobile devices #id scrolling
         * doesn't work as expected due to dynamic nature of
         * the profile settings form/page.
         *
         * Manually scroll to the section with some delay,
         * wait until all dom computation are done.
         */

        const elementPosition = parentRef.getBoundingClientRect().top + window.pageYOffset;
        const targetPosition = elementPosition - offset;

        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth',
        });
    }, [hash, parentRef]);
};
